module.exports = __webpack_public_path__ + "static/box-278690fe60874ec61dc828303a272749.png";